import '@fontsource/atkinson-hyperlegible-next/latin-400.css';
import '@fontsource/atkinson-hyperlegible-next/latin-600.css';
import '@fontsource/atkinson-hyperlegible-next/latin-700.css';
import '@fontsource/fraunces/latin-700.css';
import './styles/v2.css';
import { t, registerMessages } from './i18n.js';
import { RendererV2 } from './renderer-v2.js';
import { initShell } from './app-shell.js';

window.LanGamesV2 = {
  version: '2.0.0',
  t,
  registerMessages,
  RendererV2,
};
window.RendererV2 = RendererV2;
window.dispatchEvent(new CustomEvent('lan-games:v2-ready', {
  detail: { version: window.LanGamesV2.version },
}));

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initShell);
else initShell();
